// extracted by mini-css-extract-plugin
export default {"questionMark":"QuestionMarkIcon_questionMark__Kj8+s"};